
const NoMatch = () => {
    <>
        <div style={{display:'flex', justifyContent:'center',alignContent:'center'}}>
            <div style={{ color: 'white', fontSize: '48px' }}>No Page Found</div>
        </div>
    </>
}

export default NoMatch;